export const importQueueRu = {
  status: {
    PENDING: 'Извлечение',
    EXTRACTED: 'Извлечено',
    IGNORED: 'Игнор',
    IMPORTED: 'Опубликовано',
    REJECTED: 'Отклонено',
    DUPLICATE: 'Дубль',
  },
  filters: {
    statusLabel: 'Статус',
    any: 'Все',
    cityLabel: 'Город',
    channelLabel: 'Канал',
    fromLabel: 'С',
    toLabel: 'По',
    reset: 'Сбросить фильтры',
  },
  table: {
    headerChannel: 'Канал',
    headerCity: 'Город',
    headerPostedAt: 'Опубликовано',
    headerStatus: 'Статус',
    headerTitle: 'Заголовок',
    headerConfidence: 'Уверенность',
    headerActions: 'Действия',
    emptyTitle: 'Очередь пуста',
    emptyDescription: 'События появятся здесь после того, как LLM извлечёт их из сообщений Telegram-каналов.',
    possibleDuplicate: 'возможный дубль',
    open: 'Открыть',
    loadMore: 'Загрузить ещё',
  },
  skipReason: {
    lowConfidenceBadge: 'Уверенность {{pct}}%',
    lowConfidenceTitle: 'Низкая уверенность LLM',
    lowConfidenceDescription: 'LLM оценил уверенность в {{pct}}%, что ниже порога {{threshold}}%.',
    lowConfidenceHint: 'Проверь извлечённые поля и опубликуй вручную, если они корректны.',
    multiDateBadge: 'Мультидата ({{count}})',
    multiDateTitle: 'Несколько дат',
    multiDateDescription: 'LLM нашёл {{count}} дат для этого события.',
    multiDateHint: 'Подтверди или отредактируй список дат и опубликуй вручную.',
    noDateBadge: 'Нет даты',
    noDateTitle: 'Нет даты',
    noDateDescription: 'LLM не извлёк ни одной даты.',
    noDateHint: 'Добавь дату в форме и опубликуй вручную.',
    missingTitleBadge: 'Нет заголовка',
    missingTitleTitle: 'Нет заголовка',
    missingTitleDescription: 'LLM не извлёк заголовок события.',
    missingTitleHint: 'Заполни заголовок в форме и опубликуй вручную.',
  },
  moderation: {
    createEvent: 'Создать событие',
    publishingEllipsis: 'Публикация…',
    reextract: 'Re-extract',
    reextractSuccess: 'Запущена повторная экстракция',
    reextractError: 'Не удалось перезапустить',
    ignore: 'Игнор',
    ignoreConfirmAction: 'Игнорировать',
    ignoreConfirmTitle: 'Игнорировать сообщение?',
    ignoreConfirmDescription:
      'Сообщение исчезнет из очереди модерации, но останется в базе и не будет обработано LLM повторно.',
    ignoreSuccess: 'Помечено как игнор',
    ignoreError: 'Не удалось проигнорировать',
    reject: 'Отклонить',
    rejectConfirmTitle: 'Отклонить сообщение?',
    rejectConfirmDescription: 'Извлечённое событие не будет опубликовано. Опишите причину для аудита.',
    rejectNotePlaceholder: 'Причина отказа (опц.)',
    rejectSuccess: 'Отклонено',
    rejectError: 'Не удалось отклонить',
    cancel: 'Отмена',
    loadingEllipsis: 'Загрузка…',
    rejectingEllipsis: 'Отклонение…',
    formNotReady: 'Форма ещё не готова',
    invalidFormFields: 'Проверьте поля формы (дата, название, категории)',
    eventPublished: 'Событие опубликовано в афишу',
    publishFailed: 'Не удалось опубликовать',
    publishedToFeed: 'Опубликовано: {{label}}',
    publishedToFeedGeneric: 'Опубликовано в ленту',
    otherSectionLabel: 'Или опубликовать в другой раздел ленты',
  },
  feedPublishActions: {
    labelPrefix: 'В {{label}}',
  },
  placeMatch: {
    unlink: 'Отвязать',
    searchPlaceholder: 'Поиск места...',
    notFound: 'Не найдено',
    selectPlaceholder: 'Выберите место (опц.)',
    noMatches: 'Не нашли совпадений.',
    createNew: 'Создать новое',
  },
  publishForm: {
    organizerBlocked:
      'Организатор заблокирован — пост не публикуется. Снять блокировку можно в разделе «Блокировки организаторов».',
    cityLabel: 'Город',
    selectCity: 'Выберите город',
    tzHintPrefix: 'Время вводится в часовом поясе города: ',
    titleLabel: 'Название',
    titlePlaceholder: 'Поэтический slam',
    venueLabel: 'Место',
    venuePlaceholder: 'Бар на Бенх-Тань',
    linkPlaceLabel: 'Привязать к месту (опц.)',
    resolvingEllipsis: 'Определяем…',
    resolveFromMap: '📍 Создать место из карты поста',
    resolveMapHintPrefix: 'Резолвит ',
    resolveMapHintLink: 'карт-ссылку',
    resolveMapHintSuffix: ' через Google Places и привязывает Place (тратит квоту).',
    placeEmptyHint: 'Если оставить пустым — Event привяжется только к свободному тексту venueText.',
    placeLinkedToast: 'Место привязано: {{venueText}}',
    placeResolveError: 'Не удалось определить место по ссылке (проверьте лимит Google Places)',
    descriptionLabel: 'Описание',
    datesLabel: 'Даты',
    removeDate: 'Удалить дату',
    addDate: '+ Добавить дату',
    startTimeLabel: 'Время начала (опц., общее для всех дат)',
    endDateLabel: 'Дата конца (опц.)',
    endTimeLabel: 'Время конца (опц.)',
    categoriesLabel: 'Категории',
    priceLabel: 'Цена, в основных единицах (0 / пусто = бесплатно)',
    organizerUsernameLabel: 'Telegram-юзернейм организатора (опц.)',
    organizerUsernamePlaceholder: '@ada_lovelace',
    coverImageUrlLabel: 'Обложка (URL)',
    videoUrlLabel: 'Видео (URL)',
    publishNowLabel: 'Опубликовать сразу (иначе создастся как черновик)',
    duplicateTitle: 'Возможный дубль',
    duplicateKindEventNews: 'событие/новость',
    duplicateKindEvent: 'событие',
    duplicateSimilarToPrefix: 'Похоже на уже существующее ',
    similaritySuffix: ' — схожесть {{pct}}%',
    confirmAnyway: 'Опубликовать всё равно?',
    cancel: 'Отмена',
    publishingEllipsis: 'Публикация…',
    publish: 'Опубликовать',
    eventCreated_one: 'Событие создано',
    eventCreated_few: 'Создано {{count}} события',
    eventCreated_many: 'Создано {{count}} событий',
  },
  rawPost: {
    openInTelegram: 'Открыть в Telegram',
    authorTitle: 'Автор сообщения — подставляется организатором, если его нет в тексте',
    postTextLabel: 'Текст поста',
    empty: '(пусто)',
    mediaLabel: 'Медиа ({{count}})',
    videoLabel: 'Видео',
  },
};

/**
 * `publishForm.eventCreated_*` содержит русские плюральные суффиксы (_one/_few/_many),
 * у английской версии — свои (_one/_other) в силу другой грамматики. Ослабляем тип
 * `publishForm` до `Record<string, string>`, чтобы `importQueueEn: ImportQueueBundle`
 * не был обязан повторить ровно те же ключи-суффиксы, что и `importQueueRu`.
 */
export type ImportQueueBundle = Omit<typeof importQueueRu, 'publishForm'> & {
  publishForm: Record<string, string>;
};
